import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from '../components/Button';

import imgEleccionTratamiento from "../images/eleccion-de-tratamiento.png";

export default function PautasEjerciciosLogopediaRehabilitacion() {
  const navigate = useNavigate();
  const [imgAbierta, setImgAbierta] = useState(false);

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">PAUTAS / EJERCICIOS DE LOGOPEDIA Y REHABILITACIÓN</h3>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">En caso de que el paciente presente alteración moderada-grave de la eficacia y/o cualquier alteración de la seguridad en función del MECV-V se recomienda que sea valorado por un médico especialista en rehabilitación deglutoria.</p>

        <p className="mb-2 font-semibold">Instrucciones:</p>

        <p className="mb-2">• Paciente en sedestación, en posición cómoda y relajada, delante de un espejo.</p>

        <p className="mb-2">• Estos ejercicios no deben de cansar al paciente.</p>

        <p className="mb-2">• Precisan de colaboración activa del paciente.</p>

        <p className="mb-4">• Los ejercicios se deben adaptar según el nivel cognitivo.</p>

<img
  src={imgEleccionTratamiento}
  alt="Elección del tratamiento"
  className="w-full max-w-md mx-auto mb-8 cursor-pointer hover:opacity-90 transition"
  onClick={() => setImgAbierta(true)}
/>

{imgAbierta && (
  <div
    className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
    onClick={() => setImgAbierta(false)}
  >
    <div
      className="relative max-w-4xl w-full p-4"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={imgEleccionTratamiento}
        alt="Elección del tratamiento ampliada"
        className="w-full rounded-lg shadow-xl"
      />

      <button
        onClick={() => setImgAbierta(false)}
        className="absolute top-2 right-2 bg-white/90 rounded-full px-3 py-1 text-sm font-semibold hover:bg-white"
      >
        ✕
      </button>
    </div>
  </div>
)}

        <p>A continuación se presentan los diferentes ejercicios de este apartado:</p>
      </div>

      {/* Apartados */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => navigate("/pautas/tecnicas-incremento-sensorial")}>
          Técnicas de incremento sensorial
        </Button>

        <Button onClick={() => navigate("/pautas/maniobras-posturales")}>
          Maniobras posturales
        </Button>

        <Button onClick={() => navigate("/pautas/praxias-neuromusculares")}>
          Praxias neuromusculares
        </Button>

        <Button onClick={() => navigate("/pautas/maniobras-deglutorias-compensatorias")}>
          Maniobras deglutorias compensatorias
        </Button>
      </div>
    </div>
  );
}